import React, { useRef, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import html2pdf from 'html2pdf.js';
import { useSelector } from "react-redux";
import { selectChapterShareReport } from "../app/features/chapterReportSlice";

const ChapterFinancialReport = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const startingMonth = queryParams.get('starting_month')
    const startingYear = queryParams.get('starting_year')
    const endingMonth = queryParams.get('ending_month')
    const endingYear = queryParams.get('ending_year')
    // const chapterName = queryParams.get('chapter_name').split('_').join(' ')
    const financialData = useSelector(selectChapterShareReport)
    const chapterName = 'chapter name'
    const card1Ref = useRef(null);
    const [loading, setLoading] = useState(false)


    const exportToPDF = () => {
        setLoading(true)
        // Combine the two cards into a wrapper for rendering
        const combinedRef = document.createElement("div");
        combinedRef.style.padding = "20px"; // Padding around the content
        combinedRef.style.backgroundColor = "white";
        combinedRef.style.width = "900px"; // Increase width of the PDF content

        // Clone and append the first card
        const card1Clone = card1Ref.current.cloneNode(true);
        card1Clone.style.marginBottom = "20px"; // Gap between cards
        card1Clone.style.width = "100%"; // Make sure card takes full width
        combinedRef.appendChild(card1Clone);

        // PDF Options
        const options = {
            margin: [10, 10], // Top and bottom margin
            filename: `${chapterName}-share-report`,
            html2canvas: { scale: 2, width: 900 }, // Increase width
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };

        html2pdf()
            .set(options)
            .from(combinedRef)
            .save()
            .finally(() => setLoading(false));
    };

    return (
        <>
            <div className="pt-5 d-print-none">
                <div className="chapter-heading ">
                    <h2 className="text-center title-font text-light py-3 mt-1">Financial Report of Chapter&apos;s Share</h2>
                </div>
            </div>
            <div className="p-md-5 p-3 overallPadding">
                <div className='text-end mb-3 d-print-none'>
                    <Button onClick={() => window.history.back()} variant="contained" className='menus-color'
                    >Back</Button>
                </div>
                <div ref={card1Ref}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody >
                                <TableRow sx={{ bgcolor: 'secondary.main' }}>
                                    <TableCell align="center" colSpan={4} className="border text-white">Financial Report of Chapter’s Share</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={1} className="border">Name of the Chapter</TableCell>
                                    <TableCell colSpan={2} className="border">{chapterName}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={1} className="border">Report for the period</TableCell>
                                    <TableCell colSpan={2} className="border">From {startingMonth} {startingYear} To {endingMonth} {endingYear}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ bgcolor: 'secondary.main' }}>
                                <TableRow>
                                    <TableCell className="border text-white">Month & Year</TableCell>
                                    <TableCell className="border text-white">Membership Type</TableCell>
                                    <TableCell className="border text-white">Membership Plan</TableCell>
                                    <TableCell className="border text-white">New</TableCell>
                                    <TableCell className="border text-white">Renewal</TableCell>
                                    <TableCell className="border text-white">15% Share</TableCell>
                                    <TableCell className="border text-white">Credit</TableCell>
                                    <TableCell className="border text-white">Debit</TableCell>
                                    <TableCell className="border text-white">Balance</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {financialData.financialReport.map((report) => (
                                    report.entries.map((entry, index) => (
                                        entry.planTypes.map((plan, planIndex) => (
                                            <TableRow key={`${index}-${planIndex}`}>
                                                {planIndex === 0 && index === 0 && <TableCell className="border" rowSpan={report?.entries.reduce((acc, item) => acc += item?.planTypes.length, 0)}>{index === 0 ? `${report.month} ${report.year}` : ""}</TableCell>}
                                                {planIndex === 0 && <TableCell className="border" rowSpan={entry.planTypes.length}>{entry.membershipType}</TableCell>}
                                                <TableCell className="border">{plan.membershipPlan}</TableCell>
                                                <TableCell className="border">{plan.newCount} x {plan.amount}</TableCell>
                                                <TableCell className="border">{plan.renewalCount} x {plan.renewalAmount}</TableCell>
                                                <TableCell className="border">{plan.sharePercent}</TableCell>
                                                {planIndex === 0 && index === 0 && <TableCell className="border" rowSpan={report?.entries.reduce((acc, item) => acc += item?.planTypes.length, 0)}>{report.credit?.credit || "-"}</TableCell>}
                                                {planIndex === 0 && index === 0 && <TableCell className="border" rowSpan={report?.entries.reduce((acc, item) => acc += item?.planTypes.length, 0)}>{report.credit?.debit || "-"}</TableCell>}
                                                {planIndex === 0 && index === 0 && <TableCell className="border" rowSpan={report?.entries.reduce((acc, item) => acc += item?.planTypes.length, 0)}>{report.credit?.balance || "-"}</TableCell>}
                                            </TableRow>
                                        ))
                                    ))
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <div className="text-center mt-3"><Button onClick={exportToPDF} variant="contained" className="rounded-0 d-print-none" color="primary">{loading ? 'Generating PDF...' : 'Download as PDF'}</Button></div>
            </div>
        </>
    );
};

export default ChapterFinancialReport;
